import React, { useState, useMemo } from "react";
import { useHealthStore } from "./storeSalud";

export default function SaludCiudadano() {
  const {
    centers,
    tickets,
    createTicket,
    getSlotAvailability,
    cancelTicket
  } = useHealthStore();

  const [tab, setTab] = useState("nueva");
  const [step, setStep] = useState("centro");
  const [search, setSearch] = useState("");
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [form, setForm] = useState({ name: "", ci: "" });
  const [loadingStep, setLoadingStep] = useState(false);

  const primary = "#0A4D8C";
  const green = "#1FAF8F";
  const danger = "#c0392b";

  const goToStep = (nextStep) => {
    setLoadingStep(true);
    setTimeout(() => {
      setStep(nextStep);
      setLoadingStep(false);
    }, 500);
  };

  const filteredCenters = useMemo(() => {
    return centers.filter(center =>
      center.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, centers]);

  const containerStyle = {
    fontFamily: "Arial",
    background: "#F4F6F8",
    minHeight: "100vh",
    padding: 20,
    display: "flex",
    justifyContent: "center"
  };

  const wrapperStyle = {
    width: "100%",
    maxWidth: 800
  };

  const cardStyle = {
    background: "white",
    padding: 20,
    borderRadius: 10,
    marginBottom: 15,
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    transition: "all 0.3s ease"
  };

  const inputStyle = {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "1px solid #ddd",
    marginBottom: 15,
    fontSize: 16
  };

  const buttonStyle = {
    padding: 12,
    width: "100%",
    borderRadius: 8,
    border: "none",
    background: primary,
    color: "white",
    fontSize: 16,
    cursor: "pointer",
    marginTop: 10
  };

  const tabStyle = (active) => ({
    flex: 1,
    padding: 12,
    textAlign: "center",
    cursor: "pointer",
    background: active ? primary : "white",
    color: active ? "white" : primary,
    border: `1px solid ${primary}`
  });

  const getEstadoColor = (estado) => {
    if (estado === "pendiente") return "#f39c12";
    if (estado === "en_atencion") return "#2980b9";
    if (estado === "finalizado") return green;
    if (estado === "cancelado") return danger;
    return "gray";
  };

  return (
    <div style={containerStyle}>
      <div style={wrapperStyle}>
        <h2 style={{ color: primary }}>
          Sistema Digital de Fichas – Salud Municipal
        </h2>

        {/* TABS */}
        <div style={{ display: "flex", marginBottom: 20 }}>
          <div
            style={tabStyle(tab === "nueva")}
            onClick={() => {
              setTab("nueva");
              goToStep("centro");
            }}
          >
            Nueva Ficha
          </div>
          <div
            style={tabStyle(tab === "mis")}
            onClick={() => setTab("mis")}
          >
            Mis Fichas
          </div>
        </div>

        {/* LOADER */}
        {loadingStep && (
          <div style={{
            background: "white",
            padding: 40,
            borderRadius: 10,
            textAlign: "center",
            marginBottom: 20
          }}>
            <div style={{
              width: 40,
              height: 40,
              border: "4px solid #ddd",
              borderTop: `4px solid ${primary}`,
              borderRadius: "50%",
              margin: "0 auto 15px",
              animation: "spin 1s linear infinite"
            }} />
            <p>Cargando...</p>
          </div>
        )}

        {/* NUEVA FICHA */}
        {tab === "nueva" && !loadingStep && (
          <div style={{ opacity: 1, transition: "opacity 0.3s" }}>

            {/* PASO 1 */}
            {step === "centro" && (
              <>
                <h3 style={{ marginBottom: 20, color: primary }}>
                  Paso 1: Seleccione un Centro de Salud
                </h3>

                <input
                  type="text"
                  placeholder="Buscar centro de salud..."
                  style={inputStyle}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

                {filteredCenters.length === 0 && (
                  <div style={cardStyle}>
                    No se encontraron centros.
                  </div>
                )}

                {filteredCenters.map(center => (
                  <div key={center.id} style={cardStyle}>
                    <h3>{center.name}</h3>
                    <button
                      style={buttonStyle}
                      onClick={() => {
                        setSelectedCenter(center);
                        goToStep("servicio");
                      }}
                    >
                      Seleccionar Centro
                    </button>
                  </div>
                ))}
              </>
            )}

            {/* PASO 2 */}
            {step === "servicio" && selectedCenter && (
              <>
                <h3 style={{ marginBottom: 20, color: primary }}>
                  Paso 2: Seleccione el Servicio Médico
                </h3>

                {selectedCenter.services.map(service => (
                  <div key={service.id} style={cardStyle}>
                    <h3>{service.name}</h3>
                    <p>Duración aproximada: {service.avgTime} minutos</p>
                    <button
                      style={buttonStyle}
                      onClick={() => {
                        setSelectedService(service);
                        goToStep("horario");
                      }}
                    >
                      Seleccionar Servicio
                    </button>
                  </div>
                ))}
              </>
            )}

            {/* PASO 3 */}
            {step === "horario" && selectedService && (
              <>
                <h3 style={{ marginBottom: 20, color: primary }}>
                  Paso 3: Seleccione un Horario Disponible
                </h3>

                {selectedService.slots.map(slot => {
                  const availability = getSlotAvailability(
                    selectedCenter.id,
                    selectedService.id,
                    slot
                  );

                  return (
                    <div key={slot} style={cardStyle}>
                      <strong>{slot}</strong>
                      <p>
                        Cupos disponibles: {availability.available} / {availability.max}
                      </p>
                      <button
                        style={{
                          ...buttonStyle,
                          background:
                            availability.available > 0 ? green : "gray"
                        }}
                        disabled={availability.available <= 0}
                        onClick={() => {
                          setSelectedSlot(slot);
                          goToStep("formulario");
                        }}
                      >
                        {availability.available > 0
                          ? "Elegir Horario"
                          : "Horario Completo"}
                      </button>
                    </div>
                  );
                })}
              </>
            )}

            {/* PASO 4 */}
            {step === "formulario" && (
              <>
                <h3 style={{ marginBottom: 20, color: primary }}>
                  Paso 4: Complete sus Datos
                </h3>

                <div style={cardStyle}>
                  <input
                    placeholder="Nombre completo"
                    style={inputStyle}
                    onChange={e =>
                      setForm({ ...form, name: e.target.value })
                    }
                  />
                  <input
                    placeholder="Número de CI"
                    style={inputStyle}
                    onChange={e =>
                      setForm({ ...form, ci: e.target.value })
                    }
                  />

                  <button
                    style={buttonStyle}
                    onClick={() => {
                      createTicket({
                        centerId: selectedCenter.id,
                        serviceId: selectedService.id,
                        slot: selectedSlot,
                        name: form.name,
                        ci: form.ci
                      });
                      setTab("mis");
                    }}
                  >
                    Confirmar Ficha
                  </button>
                </div>
              </>
            )}
          </div>
        )}

        {/* MIS FICHAS */}
        {tab === "mis" && (
          <>
            {tickets.length === 0 && (
              <div style={cardStyle}>
                No tiene fichas registradas.
              </div>
            )}

            {tickets.map(ticket => {
              const center = centers.find(c => c.id === ticket.centerId);
              if (!center) return null;

              const service = center.services.find(
                s => s.id === ticket.serviceId
              );
              if (!service) return null;

              return (
                <div key={ticket.id} style={cardStyle}>
                  <h3>{center.name}</h3>
                  <p><strong>Servicio:</strong> {service.name}</p>
                  <p><strong>Horario:</strong> {ticket.slot}</p>
                  <p>
                    <strong>Estado:</strong>{" "}
                    <span style={{ color: getEstadoColor(ticket.status) }}>
                      {ticket.status}
                    </span>
                  </p>

                  {ticket.status === "pendiente" && (
                    <button
                      onClick={() => cancelTicket(ticket.id)}
                      style={{
                        marginTop: 10,
                        background: danger,
                        color: "white",
                        border: "none",
                        padding: 10,
                        borderRadius: 6,
                        cursor: "pointer"
                      }}
                    >
                      Cancelar Cita
                    </button>
                  )}
                </div>
              );
            })}
          </>
        )}

        {/* ANIMACIÓN */}
        <style>
          {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
        </style>

        {/* DISCLAIMER */}
        <div style={{ marginTop: 30, fontSize: 12, color: "#777" }}>
          ⚠️ Este es un prototipo demostrativo. No almacena información real
          ni está conectado a ningún sistema oficial.
        </div>
      </div>
    </div>
  );
}